/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wb_Sales_Body_4Inputs */

const en_wb_sales_body_4 = /** @type {(inputs: Wb_Sales_Body_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Would Tuesday at 11:00 work for a short call?`)
};

const lv_wb_sales_body_4 = /** @type {(inputs: Wb_Sales_Body_4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vai otrdien plkst. 11:00 būtu piemērots laiks īsai sarunai?`)
};

/**
* | output |
* | --- |
* | "Would Tuesday at 11:00 work for a short call?" |
*
* @param {Wb_Sales_Body_4Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const wb_sales_body_4 = /** @type {((inputs?: Wb_Sales_Body_4Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wb_Sales_Body_4Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_wb_sales_body_4(inputs)
	return en_wb_sales_body_4(inputs)
});